module.exports = __webpack_public_path__ + "img/funnel3.549749fe.svg";